// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__d7ll1","errorLogs":"EditorFooter_errorLogs__9WDMh"};